import React, { useMemo } from 'react'
import type { MenuItem } from '../../../models/types'
import DashboardItem from './DashboardItem'

interface DashboardColumnProps {
  title?: string
  tiles: Array<MenuItem>
  onClick: () => void
}

const DashboardColumn = ({ title, tiles, onClick }: DashboardColumnProps): JSX.Element => {
  const processedItems = useMemo<Array<MenuItem>>(() => {
    return tiles.slice().sort((item1, item2) => item1.index - item2.index)
  }, [tiles])

  return (
    <div className='rf-w-full rf-pt-6 rf-pb-2 rf-flex rf-flex-col rf-justify-start'>
      {/* Title */}
      {title && <div className='rf-text-lgcustom rf-font-bold rf-pb-2'>{title}</div>}

      {/* Items */}
      {processedItems.map((item, key) => {
        return (
          <div key={key} className={`rf-w-full ${key && 'rf-border-t rf-border-t-menuBorder'}`}>
            <DashboardItem {...item} textColor={undefined} onClick={onClick} />
          </div>
        )
      })}
    </div>
  )
}

export default DashboardColumn
